import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD_sCXwz1n-Aek0g4hj0rbL9Es9l7vcdRA",
  authDomain: "hyperlounge-dev.firebaseapp.com",
  projectId: "hyperlounge-dev",
  storageBucket: "hyperlounge-dev.firebasestorage.app",
  messagingSenderId: "848582894134",
  appId: "1:848582894134:web:1e0c9247ac0f2d471fee97"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
export default app;
